import { defineStore } from 'pinia';
import { computed, ref, type Ref } from 'vue';

type LoadingStore = {
    isLoaded: Readonly<Ref<boolean>>,
    hasAjaxRequests: Readonly<Ref<boolean>>,
    incrementItemsToLoad: () => void,
    decrementItemsToLoad: () => void,
    incrementAjaxRequests: () => void,
    decrementAjaxRequests: () => void,
};

export const useLoadingStore = defineStore('loading', (): LoadingStore => {
    const itemsToLoad = ref(0);
    const ajaxRequests = ref(0);

    const incrementItemsToLoad = () => {
        itemsToLoad.value += 1;
    };

    const decrementItemsToLoad = () => {
        if (itemsToLoad.value > 0) {
            itemsToLoad.value -= 1;
        }
    };

    const incrementAjaxRequests = () => {
        ajaxRequests.value += 1;
    };

    const decrementAjaxRequests = () => {
        if (ajaxRequests.value > 0) {
            ajaxRequests.value -= 1;
        }
    };

    const isLoaded = computed(() => itemsToLoad.value <= 0);
    const hasAjaxRequests = computed(() => ajaxRequests.value > 0);

    return {
        isLoaded,
        hasAjaxRequests,
        incrementItemsToLoad,
        decrementItemsToLoad,
        incrementAjaxRequests,
        decrementAjaxRequests,
    };
});
